"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetType = exports.WidgetActionDynamicStatus = exports.TreeType = exports.TGPTResponseType = exports.SortMode = exports.ServiceTypes = exports.ResponseIndex = exports.MapSurface = exports.LocationType = exports.GenIndex = exports.FormatRule = exports.FieldType = exports.ExportTypes = exports.DataType = exports.ComparisonOperator = exports.ChartType = exports.Basket = exports.Base = exports.AxisType = exports.Aggregation = void 0;
let ChartType = exports.ChartType = /*#__PURE__*/function (ChartType) {
  ChartType["BOX_PLOT"] = "boxplot";
  ChartType["BUBBLE"] = "bubble";
  ChartType["BULLET"] = "bullet";
  ChartType["COMBO"] = "combo";
  ChartType["FORM"] = "form";
  ChartType["HEATMAP"] = "heatmap";
  ChartType["HISTOGRAM"] = "histogram";
  ChartType["LABEL"] = "label";
  ChartType["MAP"] = "map";
  ChartType["PACKED_BUBBLE"] = "packed bubble";
  ChartType["PIE"] = "pie";
  ChartType["ROLLUP"] = "rollup";
  ChartType["SORTED"] = "sorted";
  ChartType["SCATTER"] = "scatter";
  ChartType["STATUS_TRACKER"] = "status tracker";
  ChartType["TABLE"] = "table";
  ChartType["TEXT"] = "text";
  ChartType["TREE"] = "tree";
  ChartType["TREEMAP"] = "treemap";
  ChartType["WATERFALL"] = "waterfall";
  ChartType["WEBVIEW"] = "webview";
  ChartType["FLOWCHART"] = "flowchart";
  ChartType["ACTIVITY_FEED"] = "activity feed";
  ChartType["SPACIAL_MAP"] = "spaciel map";
  ChartType["CALCULATOR"] = "calculator";
  ChartType["FAVORITES"] = "favorites";
  ChartType["MODULE_SELECTOR"] = "module selector";
  ChartType["SEARCH"] = "search";
  ChartType["RECOMMENDED_WIDGET"] = "Recommended widgets";
  ChartType["BUSINESS_ELEMENTS"] = "Business Elements";
  ChartType["VIEWS"] = "Views";
  ChartType["APPLICATIONS"] = "Applications";
  return ChartType;
}({});
let WidgetType = exports.WidgetType = /*#__PURE__*/function (WidgetType) {
  WidgetType["CHART"] = "Chart";
  WidgetType["TABLE"] = "Table";
  WidgetType["PIE"] = "Pie";
  WidgetType["WATERFALL"] = "Waterfall";
  WidgetType["DOUGHNUT"] = "Doughnut";
  WidgetType["PYRAMID"] = "Pyramid";
  WidgetType["FUNNEL"] = "Funnel";
  WidgetType["BOX_PLOT"] = "BoxPlot";
  WidgetType["RADIAL_BAR"] = "RadialBar";
  WidgetType["BUBBLE"] = "Bubble";
  WidgetType["SCATTER_PLOT"] = "ScatterPlot";
  WidgetType["LABEL"] = "Label";
  WidgetType["HISTOGRAM"] = "Histogram";
  WidgetType["TEXT"] = "RichText";
  WidgetType["TREEMAP"] = "Treemap";
  return WidgetType;
}({});
let Basket = exports.Basket = /*#__PURE__*/function (Basket) {
  Basket["X"] = "x";
  Basket["Y"] = "y";
  Basket["COLOR"] = "color";
  Basket["SIZE"] = "size";
  Basket["ID"] = "id";
  Basket["ID2"] = "id2";
  Basket["LABEL"] = "label";
  Basket["LATITUDE"] = "latitude";
  Basket["LONGITUDE"] = "longitude";
  Basket["LOCATION"] = "location";
  return Basket;
}({});
let FieldType = exports.FieldType = /*#__PURE__*/function (FieldType) {
  FieldType["SERIES"] = "series";
  FieldType["CATEGORY"] = "category";
  FieldType["X_AXIS"] = "xAxis";
  FieldType["Y_AXIS"] = "yAxis";
  return FieldType;
}({});
let Aggregation = exports.Aggregation = /*#__PURE__*/function (Aggregation) {
  Aggregation["NONE"] = "none";
  Aggregation["UNKNOWN"] = "unknown";
  Aggregation["SUM"] = "sum";
  Aggregation["COUNT"] = "count";
  Aggregation["AVERAGE"] = "average";
  Aggregation["COUNTU"] = "unique-count";
  Aggregation["STDEV"] = "standard-deviation";
  Aggregation["VARIANCE"] = "variance";
  Aggregation["MIN"] = "min";
  Aggregation["Q1"] = "q1";
  Aggregation["MEDIAN"] = "median";
  Aggregation["Q3"] = "q3";
  Aggregation["MAX"] = "max";
  return Aggregation;
}({}); // same as Q4
let Base = exports.Base = /*#__PURE__*/function (Base) {
  Base["K"] = "K";
  Base["M"] = "M";
  Base["B"] = "B";
  Base["DYNAMIC"] = "D";
  return Base;
}({});
let AxisType = exports.AxisType = /*#__PURE__*/function (AxisType) {
  AxisType["LINE"] = "linear";
  AxisType["LOG"] = "logarithmic";
  AxisType["DATETIME"] = "datetime";
  AxisType["CATEGORY"] = "category";
  return AxisType;
}({});
let LocationType = exports.LocationType = /*#__PURE__*/function (LocationType) {
  LocationType["GEO"] = "geo";
  LocationType["COUNTRY"] = "country";
  LocationType["STATE"] = "state";
  LocationType["COUNTY"] = "county";
  return LocationType;
}({});
let MapSurface = exports.MapSurface = /*#__PURE__*/function (MapSurface) {
  MapSurface["HYBRID"] = "hybrid";
  MapSurface["ROADMAP"] = "roadmap";
  MapSurface["SATELLITE"] = "satellite";
  MapSurface["TERRAIN"] = "terrain";
  return MapSurface;
}({});
let ComparisonOperator = exports.ComparisonOperator = /*#__PURE__*/function (ComparisonOperator) {
  ComparisonOperator["GREATER_THAN"] = ">";
  ComparisonOperator["LESS_THAN"] = "<";
  ComparisonOperator["EQUAL"] = "=";
  ComparisonOperator["NOT_EQUAL"] = "<>";
  ComparisonOperator["LESS_THAN_OR_EQUAL"] = "<=";
  ComparisonOperator["GREATER_THAN_OR_EQUAL"] = ">=";
  ComparisonOperator["CONTAINS"] = "<c>";
  ComparisonOperator["NOT_CONTAINS"] = "<nc>";
  ComparisonOperator["STARTS_WITH"] = "<s>";
  ComparisonOperator["ENDS_WITH"] = "<e>";
  ComparisonOperator["IN"] = "<i>";
  ComparisonOperator["NOT_IN"] = "<ni>";
  ComparisonOperator["BETWEEN"] = "<b>";
  ComparisonOperator["NOT_BETWEEN"] = "<nb>";
  return ComparisonOperator;
}({});
let FormatRule = exports.FormatRule = /*#__PURE__*/function (FormatRule) {
  FormatRule["GREATER_THAN"] = "GreaterThan";
  FormatRule["LESS_THAN"] = "LessThan";
  FormatRule["EQUAL"] = "EqualTo";
  FormatRule["NOT_EQUAL"] = "NotEqualTo";
  FormatRule["LESS_THAN_OR_EQUAL"] = "LessThanorEqualTo";
  FormatRule["GREATER_THAN_OR_EQUAL"] = "GreateThanorEqualTo";
  FormatRule["CONTAINS"] = "Contains";
  FormatRule["NOT_CONTAINS"] = "NotContains";
  FormatRule["STARTS_WITH"] = "StartsWith";
  FormatRule["ENDS_WITH"] = "EndsWith";
  FormatRule["IN"] = "In";
  FormatRule["NOT_IN"] = "NotIn";
  FormatRule["BETWEEN"] = "Between";
  FormatRule["NOT_BETWEEN"] = "InBetween";
  return FormatRule;
}({});
let TreeType = exports.TreeType = /*#__PURE__*/function (TreeType) {
  TreeType["TABLE"] = "table";
  return TreeType;
}({});
let DataType = exports.DataType = /*#__PURE__*/function (DataType) {
  DataType["TEXT"] = "Text";
  DataType["DATE"] = "DateTime";
  DataType["NUMBER"] = "Number";
  return DataType;
}({});
let TGPTResponseType = exports.TGPTResponseType = /*#__PURE__*/function (TGPTResponseType) {
  TGPTResponseType[TGPTResponseType["Auto"] = 0] = "Auto";
  TGPTResponseType[TGPTResponseType["Text"] = 1] = "Text";
  TGPTResponseType[TGPTResponseType["Widget"] = 2] = "Widget";
  TGPTResponseType[TGPTResponseType["Image"] = 3] = "Image";
  TGPTResponseType[TGPTResponseType["Video"] = 4] = "Video";
  TGPTResponseType[TGPTResponseType["URL"] = 5] = "URL";
  TGPTResponseType[TGPTResponseType["Data"] = 6] = "Data";
  TGPTResponseType[TGPTResponseType["Unknown"] = 255] = "Unknown";
  return TGPTResponseType;
}({});
let WidgetActionDynamicStatus = exports.WidgetActionDynamicStatus = /*#__PURE__*/function (WidgetActionDynamicStatus) {
  WidgetActionDynamicStatus["DISABLE"] = "Disable";
  WidgetActionDynamicStatus["HIDE"] = "Hide";
  WidgetActionDynamicStatus["NONE"] = "None";
  return WidgetActionDynamicStatus;
}({});
let ExportTypes = exports.ExportTypes = /*#__PURE__*/function (ExportTypes) {
  ExportTypes[ExportTypes["Excel"] = 1] = "Excel";
  ExportTypes[ExportTypes["PDF"] = 2] = "PDF";
  return ExportTypes;
}({});
let SortMode = exports.SortMode = /*#__PURE__*/function (SortMode) {
  SortMode[SortMode["Ascending"] = 1] = "Ascending";
  SortMode[SortMode["Descending"] = 2] = "Descending";
  return SortMode;
}({});
let ServiceTypes = exports.ServiceTypes = /*#__PURE__*/function (ServiceTypes) {
  ServiceTypes[ServiceTypes["Unknown"] = 0] = "Unknown";
  ServiceTypes[ServiceTypes["Concept"] = 1] = "Concept";
  ServiceTypes[ServiceTypes["Insight"] = 2] = "Insight";
  ServiceTypes[ServiceTypes["TimeSeries"] = 3] = "TimeSeries";
  ServiceTypes[ServiceTypes["Link"] = 4] = "Link";
  ServiceTypes[ServiceTypes["Property"] = 5] = "Property";
  ServiceTypes[ServiceTypes["Tree"] = 6] = "Tree";
  ServiceTypes[ServiceTypes["TransactionDataNode"] = 7] = "TransactionDataNode";
  return ServiceTypes;
}({});
let GenIndex = exports.GenIndex = /*#__PURE__*/function (GenIndex) {
  GenIndex[GenIndex["Low"] = 0] = "Low";
  GenIndex[GenIndex["Medium"] = 1] = "Medium";
  GenIndex[GenIndex["High"] = 2] = "High";
  return GenIndex;
}({});
let ResponseIndex = exports.ResponseIndex = /*#__PURE__*/function (ResponseIndex) {
  ResponseIndex[ResponseIndex["Low"] = 0] = "Low";
  ResponseIndex[ResponseIndex["Medium"] = 1] = "Medium";
  ResponseIndex[ResponseIndex["High"] = 2] = "High";
  return ResponseIndex;
}({});